import React from 'react';
import { Layout } from 'react-feather';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const TemplateEmptyState = () => (
  <div className="d-f fd-c ai-c mt-24 mb-24">
    <Layout size="75" strokeWidth="1.5" className="c-midnight-20" />
    <Text variant={TEXT_VARIANTS.SUBHEADER}>
      {t('contents.library.template_library.empty_state.header')}
    </Text>
    <Text
      variant={TEXT_VARIANTS.BODY_LIGHT}
      className="ta-c"
      style={{ maxWidth: '250px' }}
    >
      {t('contents.library.template_library.empty_state.subheader')}
    </Text>
  </div>
);

export default TemplateEmptyState;
